import { render, staticRenderFns } from "./audioPlay.vue?vue&type=template&id=df884ba2&scoped=true"
import script from "./audioPlay.vue?vue&type=script&lang=js"
export * from "./audioPlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df884ba2",
  null
  
)

export default component.exports